
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/referrals",
      function () {
        return require("private-next-pages/mobiworkx/referrals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/referrals"])
      });
    }
  